import { Fields } from '../../../constants';
import { TextField, type TextFieldProps } from '../TextField';

const name = Fields.USERNAME;

export const UsernameField = (props: Pick<TextFieldProps, 'fullWidth'>) => <TextField name={name} {...props} />;
